import { Injectable, signal } from "@angular/core";

export interface ToastOptions {
  text: string;
  icon: string;
  success: boolean;
  dismissButton: boolean;
  hasMarginBottom?: boolean;
}

interface ToastServiceOptions extends ToastOptions {
  minTime?: number | null;
}

@Injectable({ providedIn: "root" })
export class ToastService {
  private _state = signal<ToastServiceOptions | null>(null);

  state = this._state.asReadonly();

  private _timer: ReturnType<typeof setTimeout> | null = null;

  show(options: ToastServiceOptions): void {
    const minTime = options.minTime ?? 5000;

    if (this._timer) clearTimeout(this._timer);
    this._state.set(options);
    this._timer = setTimeout(() => this.dismiss(), minTime);
  }

  dismiss(): void {
    if (this._timer) clearTimeout(this._timer);
    this._timer = null;
    this._state.set(null);
  }
}
